import angular from 'angular';
import BrandsComponent from './brands.component';

let BrandsModule = angular.module('home.brands', [])
  .component('brands', BrandsComponent);

export default BrandsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/brands/brands.js
 **/